module.exports = __webpack_public_path__ + "img/tu05.b1c72862.png";